/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_New_Submit_PnkInputs */

const vi_sl_new_submit_pnk = /** @type {(inputs: Sl_New_Submit_PnkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu`)
};

/**

* @param {Sl_New_Submit_PnkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_submit_pnk = /** @type {((inputs?: Sl_New_Submit_PnkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_Submit_PnkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_submit_pnk(inputs)
});